import IndividualTable from "../../../IndividualTable";
import { sampleData2 } from "../../sampleData";

const Distance30 = () => {
  return <IndividualTable matchType={"PRE"} gender="F" event="30" subTitle="Zamby" data={sampleData2} topRankCount="16" />;
};
export default Distance30;
